
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class ContentFooter extends Vue {
  render() {
    return (
      <div>
        <div class="inner-content">
          <div class="rely-on">
            <h4>不再漂泊 不再无依靠</h4>
            <p>
              你可以在雷拓尔菲公寓拥有一个港湾，一间私人公寓，是你在商场奋斗的避风港，是你踏出校门实现梦想接近美好生活放松身心的家。
            </p>
            <div class="rely-dec">
              <div class="dec-item">
                <div>50W</div>
                <div>注册用户</div>
              </div>
              <div class="dec-item">
                <div>40W</div>
                <div>业主签约</div>
              </div>
              <div class="dec-item">
                <div>60W</div>
                <div>出租房间</div>
              </div>
            </div>
          </div>
        </div>

        <div class="live">
          <span>“</span>
          你只管住，剩下的我们来解决
          <span>”</span>
        </div>
        <div class="inner-content">
          <div class="icon-wrap">
            <div>
              <img src={require("@/assets/icon1.png")} />
              <div>足不出户</div>
              <div>在线选房/在线签约/在线交易</div>
            </div>
            <div>
              <img src={require("@/assets/icon2.png")} />
              <div>抛弃蜗居</div>
              <div>整租/合租/精品公寓</div>
            </div>
            <div>
              <img src={require("@/assets/icon3.png")} />
              <div>避风港湾</div>
              <div>自由/快了/新空间</div>
            </div>
            <div>
              <img src={require("@/assets/icon4.png")} />
              <div>闪电服务</div>
              <div>在线保修/免费WIFI/双周保洁</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
